import {random,part, s, p, execute} from './scripting.js';
import {getScriptForTitleSync} from 'decentralized/scripting/scripting.js';
import {WIDTH, HEIGHT} from 'components/effects/plane/constants.js';
import {mac} from './mac.js';
import {cond} from './flow.js';
import {source} from './source.js';
import {loop} from './loop.js';
import {interpolateSnapshot, nextSnapshot, snapshot} from './snapshot.js';
import {rewind, reset} from './time.js';
import {search, byDevice, not} from './search.js';
import {send, receive} from './msg.js';
import {translate} from './translate.js';
import {bounce} from './bounce.js';
import {vectorField} from './vector-fields.js';
import {slow, clear} from './density.js';
import {
    swap,
    life,
    expand,
    rotate} from './operations.js';
import {alt, every} from './alt.js';
import {beat} from './beat.js';

export default superclass => class extends superclass  {

    code = "";
    script = undefined;

    eval(code) {
        let values = this.clearVariables();
        this.code = code;
        this.script = this.evalWithContext(code);

        for (let name in values) {
            if (this[name + 'Parameter']) {
                this[name + 'Parameter'].copyFrom(
                    values[name], this.track.sequencerEngine);
            }
        }
        this.updateVariablesRedux();
    }

    hasSyntaxError(str) {
        return this.evalWithContext(str) === undefined;
    }

    restartScript() {
        if (this.code === "") {
            return;
        }
        this.eval(this.code);
    }

    evalWithContext(str) {
        try {
            let pieces = str.split(";");
            let last = pieces[pieces.length - 1];
            let preamble = pieces.slice(0, pieces.length - 1).join(";");
            let code = "with(this) { " + preamble + "; return s(" + last + ")}";
            return (new Function(code)).call({
                rotate,
                translate,
                s,
                random,
                every,
                loop,
                snapshot,
                byDevice,
                life,
                send,
                rewind,
                reset,
                alt,
                slow,
                clear,
                swap,
                beat,
                bounce,
                vectorField,
                expand,
                search,
                p,
                part,
                interpolateSnapshot,
                nextSnapshot,
                load: (name) => this.loadScript(name),
                receive,
                sin: Math.sin,
                cos: Math.cos,
                tan: Math.tan,
                source,
                cond,
                mac,
                not,
                WIDTH,
                HEIGHT,
                knob: (name, val, min=0, max=100) =>
                    {
                        let v = this.newVar(name, val, min, max);
                        return () => this[name+'Parameter'].get();
                    }
            });
        } catch (e) {
            // console.log('error = ', e);
            return undefined;
        }
    }

    loadScript(name) {
        let code = getScriptForTitleSync(name);
        let ctxt = this.evalWithContext(code, false);
        return () => ctxt; 
    }


}
